import { render, staticRenderFns } from "./reporte-docente-individual.vue?vue&type=template&id=f521b9b2"
import script from "./reporte-docente-individual.vue?vue&type=script&lang=js"
export * from "./reporte-docente-individual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports